import apiClient from "./api.client.service";

class ZohoRecruitService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getAllOpportunities(appJobPostId:string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/app-integration/zoho/opportunities/${appJobPostId}`,
      );
      return response?.data || [];
    } catch (error: any) {
      console.error(
        "🚀 ~ ZohoRecruitService ~ getAllOpportunities ~ error:",
        error,
      );
    }
  }
}

const zohoRecruitService = new ZohoRecruitService();

export default zohoRecruitService;
